import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
//import Slider from 'react-slick';

import ScrollAnimation from 'react-animate-on-scroll';

import Banner from '../components/Banner';
//import MapStreet from '../components/MapStreet'
//<MapStreet className="leaflet-container" />
//import StreetMap from '../components/StreetMap' 
//import MapStreet from '../components/PigeonMap';
// <section><MapStreet /></section>
import Scrollchor from 'react-scrollchor';

//import pic01 from '../assets/images/web_programming.jpg'
//import pic02 from '../assets/images/concentric.jpg'
//import pic03 from '../assets/images/applis.jpg'
//import pic04 from '../assets/images/conseil.jpg'
//import pic05 from '../assets/images/conseil.jpg'
//import pic06 from '../assets/images/call-center.jpg'
import pic07 from '../assets/images/antoine.png';
import electralpes from '../assets/images/electralpes.jpg';
import logo from '../assets/images/logo_blanc_full_small.png';
//import reponsive from '../assets/images/responsive.svg';

//style={{background: `linear-gradient(rgba(255,255,255,.5), rgba(255,255,255,.5)),cover, url(${pic01})`}}
//<Banner />

const sliderSettings = {
    //dots: true,
    infinite: true,
    speed: 500,
    centerMode: true,
    adaptiveHeight: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    rows: 3
};

class HomeIndex extends React.Component {

    render() {
		const siteUrl = this.props.data.site.siteMetadata.siteUrl;
        const siteTitle = this.props.data.site.siteMetadata.title
        const siteDescription = this.props.data.site.siteMetadata.description
        const siteKeyWords = this.props.data.site.siteMetadata.keywords;
        /*
                            <section id="clients">
                                <div className="inner">
                                    <header>
                                        <h2><span className="icon alt fa-user"></span> Clients</h2>
                                     </header>
                                    <Slider {...sliderSettings}>
                                        <div><img src={electralpes}></img></div>
                                        <div><img src={electralpes}></img></div>
                                        <div><img src={electralpes}></img></div>
                                    </Slider>
                                </div>
                            </section>
        
        */
        return (
            <div style={this.props.transition && this.props.transition.style}>
                <Helmet>
                    <title>{siteTitle}</title>
                    <meta name="description" content={siteDescription} />
                    <meta name="keywords" content={siteKeyWords} />
					<meta name="language" content="fr-FR" />
					<meta http-equiv="content-type" content="text/html; charset=UTF-8" />
					<meta http-equiv="content-language" content="fr-FR" />
					<meta property="og:title" content={siteTitle} />
                    <meta property="og:locale" content="fr_FR" />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content={siteTitle} />
					<meta property="og:description" content={siteDescription} />
                    <meta property="og:url" content={siteUrl}/>
                    <meta property="og:image" content={logo}/>
					<meta name="twitter:card" content="" />
					<meta name="twitter:site" content={siteUrl} />
					<meta name="twitter:title" content={siteTitle} />
					<meta name="twitter:image" content={logo} />
					<meta name="twitter:description" content={siteDescription} />
					<link rel="canonical" href={siteUrl} />
                </Helmet>
                <Banner />
                <div id="main">
                    <section id="services" className="tiles">
                        <article>
                            <header className="major">
                                <h3><i className="icon fa-gear"></i>Infrastructure</h3>
                                <p>Suivi global, conseil ou assistance ponctuelle de votre système d’information : systèmes, réseaux et sécurité</p>
                            </header>
                            <Link to="/infrastructure-informatique/" title="Intégration et audit systèmes d'informations" className="link primary"></Link>
                        </article>
                        <article>
                            <header className="major">
                                <h3><i className="icon fa-support"></i>Assistance</h3>
                                <p>Accompagnement ou conseil dans le choix, la mise en place et la mise à jour de vos solutions matérielles et logicielles</p>
                            </header>
                            <Link to="/assistance-informatique/" title="Conseil et assistance informatique" className="link primary"></Link>
                        </article>
                        <article>
                            <header className="major">
                                <h3><i className="icon fa-shield"></i>Suivi securite</h3>
                                <p>Expertise, conseil et mises à jour de sécurité de sites web, applications, postes de travail, serveurs, pare-feu et réseaux informatique...</p>
                            </header>
                            <Link to="/configuration-et-suivi-securite-informatique/" title="Suivi sécurité mensuel" className="link primary"></Link>
                        </article>
                        <article>
                            <header className="major">
                                <h3><i className="alticon-responsive" ></i>Sites & Applis</h3>
                                <p>Création, gestion et référencement de votre site web vitrine ou e-boutique & développement d’applications sur mesure</p>
                            </header>
                            <Link to="/creation-sites-internet-et-applications/" title="creation et référencement de sites web et d'applications" className="link primary"></Link>
                        </article>
                    </section>
                    <section id="about" className="spotlights">
                        <ScrollAnimation animateIn="fadeIn" data-content="MON CV" className="image center">
                            <img className="logo" src={pic07} alt="Photo Antoine" />
                            <Link to="/cv/" title="Mon curriculum vitae"><button className="button">MON CV <i className="icon fa-graduation-cap"></i></button></Link>
                        </ScrollAnimation>
                        <div className="content">
                            <div className="inner-center-medium">
                                <header>
                                    <Link to="/cv/" title="Mon curriculum vitae"><h2><span className="icon alt fa-user"></span>  Antoine</h2></Link>
                                </header>
                                <p className="center-medium">Ingénieur informatique de formation, je travaille depuis huit ans dans la sécurité et les réseaux informatiques pour la Métropole de Grenoble. Passionné d'informatique, j'ai pu apprendre dans des domaines variés : conseil, maintenance, assistance et expertise informatique systèmes, réseaux et sécurité, développement d'applications et de sites web et enfin gestion de projet. Addict de la montagne depuis de nombreuses années, j'ai décidé de m'installer et de lancer mon activité aux Deux Alpes en 2018.</p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}

export default HomeIndex

export const pageQuery = graphql`
    query PageQuery {
        site {
            siteMetadata {
                title
                description	
				keywords
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/pages/index.js